import { render, staticRenderFns } from "./GoodsPromotion.vue?vue&type=template&id=13ced5a2&scoped=true"
import script from "./GoodsPromotion.vue?vue&type=script&lang=js"
export * from "./GoodsPromotion.vue?vue&type=script&lang=js"
import style0 from "./GoodsPromotion.vue?vue&type=style&index=0&id=13ced5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ced5a2",
  null
  
)

export default component.exports